import React from 'react'

import { useAuth } from '../components/auth/AuthContext'
import { useMessagesActions } from '../state/actions/messages'
import Messages from '../components/messages/Messages'
import PublicContainer from '../components/containers/PublicContainer'
import CenterLayout from '../components/ui/layouts/CenterLayout'
import LoginForm from '../components/auth/LoginForm'
import LogoUFFS from '../components/ui/LogoUFFS'

export default (props) => {
  const { login } = useAuth()
  const { clearAndAddMessage } = useMessagesActions()

  return (
    <PublicContainer pageTitle="Cadastro - UFFS">
      <CenterLayout>
        <LogoUFFS />

        <div className="box">
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <h1 className="title is-3">
              Acesso ao Cadastro e Acesso para Visitantes - CAV
            </h1>
            <p className="subtitle is-5" style={{ marginBottom: '30px' }}>
              Informe seu idUFFS para acessar o sistema
            </p>
          </div>

          <Messages />

          <LoginForm
            onSubmit={() =>
              clearAndAddMessage({
                type: 'loading',
                text: `Enviando dados...`,
              })
            }
            onCompleted={(token) => {
              clearAndAddMessage({
                text: `Bem-vindo ao sistema CAV!`,
              })
              login(token)
            }}
            onError={(error) =>
              clearAndAddMessage({ type: 'error', text: error.message })
            }
          />
        </div>

        <div className="box-footer">
          Diretoria de Infraestrutura de Informações - DITI
          <br /> Secretaria Especial de Tecnologia e Informação - SETI
        </div>
      </CenterLayout>
    </PublicContainer>
  )
}
